module.exports = __webpack_public_path__ + "d0723dc2998f88753246f766de56c5ae.svg";